import {
    computed,
    ref,
    defineComponent, onMounted, reactive, toRefs, onBeforeUnmount
} from '@vue/composition-api';
import { immediateSendLog, getKwaiLog, radarLog, sendLog, getShareCommonParams } from '@common/log';
import { serialize, jumpOneLink, getTargetUrl, getOnelink, isIOSClient, isIphoneSafari, formateNum } from '@common/util';
import { callApp } from '@common/call-app';
import { getLiveInfo } from '@services/share/live';
import cookies from 'js-cookie';
// import Loading from './components/loading/index.vue';
import NewBanner from './components/new-banner/index.vue';
// import LiveEnd from './components/live-end/index.vue';

export const ONELINK_DATA = {
    KWAI_BULLDOG: 'https://snack-ios.onelink.me/hpTj/liveshare',
    KWAI: 'https://go.onelink.me/iGO2/5bbbb3b4',
    'KWAI.ME': 'https://liveshare.onelink.me/hRwu?pid=liveshare&c=discover',
    default: 'https://go.onelink.me/iGO2/5bbbb3b4',
};

export default defineComponent({
    components: {
        // 'loading': Loading,
        'new-banner': NewBanner,
        'live-end': () => import('./components/live-end/index.vue'),
        'loading': () => import('./components/loading/index.vue'),
        'hls-video': () => import('./components/video/HLSVideo.vue'),
        'popup': () => import('./components/popup/index.vue'),
        'profile-banner': () => import('./components/profile-banner/index.vue'),
    },
    setup(props, ctx) {
        const fmp_time = Date.now();
        const {
            initData: { kpn, query, abConfig, liveInfo: {
                userInfo, liveStreamId, liveCoverUrl, isLiving = false, liveOriginalSource, shareUserId, hlsPlayUls,
            }, lang: localLang, rtl: isRtl, shareUserInfo, kpnInfo, ASSETS },
            message: { livePageConf },
        } = ctx.root.$store.state;
        console.log(hlsPlayUls);
        const inNewLiveStyle = livePageConf.livePageReconsitutionExp;
        const userId = userInfo?.userId || '';
        const deviceId = (cookies.get('_did') || '') as string;
        const shareLogPara = getShareCommonParams(query);
        const hasKpn = !!(query?.kpn);
        const liveAuthorSnackId = !!(query?.liveAuthorSnackId);
        const isOldSnackVideo = (!hasKpn) && liveAuthorSnackId;
        const isFromGoogle = ref(false);

        // 如果是老版本snackvideo直播分享页
        if (isOldSnackVideo) {
            shareLogPara.share_item_type = 'live';
            shareLogPara.share_item_info = liveStreamId;
            shareLogPara.share_device_id = deviceId;
            shareLogPara.share_uid = query?.shareUserId || 0;
        }


        const getHlsPlayUls = (val: string) => {
            return val.replace(/(http:|https:)/, window.location.protocol);
        };

        const state = reactive({
            hideCover: false,
            verticalScreen: false,
            liveEndWhileLiving: false,
            showDialog: false,
            firstPopupPlay: true,
            firstClickPlay: true,
            watchTime: 30000,
            intervalTime: 10000,
            autoTime: null,
            isOperate: false,
            isWaiting: false,
            isPlaying: false,
            isLiving,
            hlsPlayUls: '',
            liveCoverUrl: liveCoverUrl || userInfo?.userHead || '',
            userHead: userInfo?.userHead,
            live_share_finish: localLang.live_share_finish,
            liveOriginalSource,
            isPlayed: false,
            delayTimer: null,
        });

        const logParam = {
            author_id: userInfo.userId,
            live_stream_id: liveStreamId,
            share_user_id: shareUserId,
            anchor_id: userInfo.userId,
            ...shareLogPara,
        };

        const pressUserOrFollowHandler = (key: string, popupArea: string) => {
            console.log(popupArea, 'popupArea');
            const type = key;
            const actions = {
                follow: 'USER_FOLLOW',
                join: 'CLICK_JOIN_NOW',
                popup: 'WATCH_WITH_KWAI_POPUP_BUTTON',
                cover: 'COVER',
                profileinfo: 'AUTHOR_INFORMATION_AREA',
                end: 'LIVE_END_FOLLOW_BUTTON',
                topbanner: 'TOP_BANNER_CARD',
                bottombanner: 'BOTTOM_BANNER_CARD',
            };

            radarLog({
                name: 'LIVE_WATCH_OUTH5',
                event_type: 'click',
                category: 'KWAI_SHARE',
                message: `点击 ${actions[type]} 次数`,
                src: window.location.pathname,
            });

            const schemeTargetURL = serialize({ target_url: decodeURIComponent(getTargetUrl(window.location.href, actions[type])) });
            const onelinkHost = ONELINK_DATA[kpn];
            const scheme = `profile/${query.liveAuthorId}?${schemeTargetURL}`;
            const newScheme = `live/play/${query.liveAuthorId}?${schemeTargetURL}&operation_source=h5_share&end_to_profile=true`;
            // deep_link_value：GP下载app打开后自动跳转对应的页面
            const deep_link_value = encodeURIComponent(`ikwai://live/play/${query.liveAuthorId}`);
            let deepLinkQueryStr = '';
            if (abConfig.shareGpUserFeedBackAb === 'ikwai_link') {
                deepLinkQueryStr = `&deep_link_value=${deep_link_value}`;
            }

            const onelink = `${onelinkHost}?pid=H5${deepLinkQueryStr}&af_channel=share&c=live`;
            const computedClickSource = key => {
                let finalSource = '';
                if (key !== 'join' && key !== 'follow') {
                    finalSource = key;

                    return finalSource;
                }
                return key === 'join' ? 'bottombanner' : 'topbanner';
            };

            const finalParam = () => {
                if (key === 'popup') {
                    return ['OK', 'PIC'].includes(popupArea) ?
                        {
                            ...logParam,
                            button_name: popupArea,
                            is_convertible_click: 'TRUE',
                        } :
                        {
                            ...logParam,
                            button_name: popupArea,
                        };
                }
                if (['cover', 'profileinfo', 'end', 'topbanner', 'bottombanner'].includes(key)) {
                    return {
                        ...logParam,
                        is_convertible_click: 'TRUE',
                    };
                }
                return logParam;

            };
            if (popupArea === 'CANCEL') {
                sendLog({
                    type: 'click',
                    name: `${actions[type]}`,
                    value: finalParam(),
                });
                return;
            }
            jumpOneLink(getOnelink(onelink, computedClickSource(key)), {
                type: 'click',
                name: `${actions[type]}`,
                value: finalParam(),
            },
                inNewLiveStyle ? newScheme : scheme);
        };

        const userIsOperate = intervalTime => {
            console.log('userIsOperate function');

            clearTimeout(state.autoTime); // 清除自动刷新页面定时器
            state.isOperate = true; // 让判断条件为true
            state.autoTime = setTimeout(() => {
                state.isOperate = false; // 页面无操作后0秒，重时开启定时器
            }, intervalTime);

            // 此操作只用来关闭弹窗,不唤端
            if (state.showDialog) {
                state.showDialog = false;

            }

            pressUserOrFollowHandler('cover', '');
        };

        const playWaitingHandler = () => {
            console.log('waiting');
            // state.isWaiting = true;
        };

        const setWaiting = waitingState => {
            console.log(waitingState, 'setWaiting');
            state.isWaiting = waitingState;
        };

        const startPopupTiming = startTiming => {
            if (state.firstPopupPlay && startTiming) {
                state.hideCover = true;
                console.log('firstPopupPlay');
                state.firstPopupPlay = false;
                setTimeout(() => {
                    state.showDialog = true;
                    immediateSendLog({
                        type: 'show',
                        name: 'WATCH_WITH_KWAI_POPUP',
                        value: logParam,
                    });
                }, state.watchTime);
            }
        };

        const playerPlayingHandler = () => {


            console.log('playerPlayingHandler');
            // state.isWaiting = false;
        };

        const userActiveHandler = () => {
            userIsOperate(state.intervalTime);
        };

        const resizeVideo = e => {
            if (state.verticalScreen) {
                return;
            }
            const width = e.target.videoWidth;
            const height = e.target.videoHeight;

            if (height / width > 1.5) {
                console.log('拉伸');
                state.verticalScreen = true;
            }
        };

        const userCallApp = clickSource => {
            // android自动打开app
            callApp(
                {
                    timeout: 2500,
                    onelink: null,
                    path: `live/play/${query.liveAuthorId}?target_url=${getTargetUrl(window.location.href, clickSource)}&operation_source=h5_share&end_to_profile=true`,
                },
                () => {
                    // sendLog({
                    //     type: 'show',
                    //     name: 'APP_NOT_INSTALLED_H5',
                    //     value: {
                    //         ...logParam,
                    //         anchor_id: userId,
                    //         group_id: livePageConf.groupId,
                    //         meta_group_id: metaConfig.groupId,
                    //         url: window.location.href,
                    //     },
                    // });

                    // radarLog({
                    //     name: 'APP_NOT_INSTALLED_H5',
                    //     event_type: 'pv',
                    //     category: 'KWAI_SHARE',
                    //     message: '未安装APP pv',
                    //     src: window.location.pathname,
                    // });
                }
            );
        };

        const playingHandler = () => {
            const video = document.getElementsByTagName('video')[0];
            // 有的机型canplay不起作用,canplay只会触发一次，不用担心重复计算
            video.addEventListener('canplay', resizeVideo);

            // state.verticalScreen为true返回是为了防止重复计算
            video.addEventListener('resize', resizeVideo);

            video.addEventListener('timeupdate', resizeVideo);

            immediateSendLog({
                type: 'click',
                name: 'PLAY_PHOTO',
                value: {
                    ...logParam,
                    is_convertible_click: 'TRUE',
                },
            });
            console.log('play start');
            state.isPlaying = true;
            state.isWaiting = true;
            state.isPlayed = true;

            if (state.firstClickPlay && !isIphoneSafari()) {
                state.firstClickPlay = false;
                userCallApp('play');
            }

        };

        const playEndHandler = async () => {
            try {
                const data: any = await getLiveInfo({
                    authorId: query.liveAuthorId,
                    userId: query.shareUserId || query.share_uid || query.fid,
                    kpn,
                });
                if (data.result === 1) {
                    console.log(data, 'may be end live');
                    if (!data.isLiving) {
                        console.log('live end');
                        state.liveEndWhileLiving = true;
                        state.isLiving = false;
                        state.isPlaying = false;

                        // 直播结束后延迟3s弹窗
                        if (+abConfig?.blockTime) {
                            const delay = state.isPlayed ? 3000 : 0;
                            delayShowDialog(delay);
                        }
                    } else {
                        state.isPlaying = true;
                        const { hlsPlayUls: playUrls } = data;
                        const hlsPlayUls = playUrls?.master?.url || playUrls?.backup?.url;
                        if (hlsPlayUls !== state.hlsPlayUls) {
                            state.isLiving = true;
                            state.hlsPlayUls = getHlsPlayUls(hlsPlayUls);
                        }
                    }
                }
            } catch (e) { /* */ }
        };

        const eventTracking = () => {
            try {
                const webLogger = getKwaiLog();
                webLogger?.plugins?.radar && webLogger.plugins.radar.fmp(fmp_time);

                immediateSendLog({
                    type: 'pv',
                    name: 'LIVE_WATCH_OUTH5',
                    value: {
                        author_id: userId,
                        url: window.location.href,
                        live_stream_id: liveStreamId,
                        ...shareLogPara,
                    },
                });

            } catch (error) {
                console.error(error);
            }

        };

        const judegClickNewBottomBanner = path => {
            if (!path || path?.length < 0) {
                return;
            }
            // 检测a标签方式跳转scheme
            if (path[0].nodeName === 'A' && path[0]?.href?.includes('ikwai')) {
                return true;
            }
            const check = pathItem => {
                return pathItem?._prevClass?.includes('newFixedBottomHeader');
            };
            return path.findIndex(check) !== -1;
        };

        const addDialogHint = () => {
            // 当有鼠标和键盘激活时清除自动刷新页面定时器
            // document.onscroll =
            // document.onkeydown =
            // document.onmousemove =
            document.onclick =
                // document.ontouchmove =
                function (e: any) {
                    // console.log(e);
                    // 点击弹窗之外的区域关闭弹窗,点击底部banner之外的区域隐藏底部banner
                    if (
                        e?.target?._prevClass?.includes('middle') ||
                        e?.target?._prevClass?.includes('van-dialog') ||
                        judegClickNewBottomBanner(e.path) ||
                        !state.isPlaying
                    ) {
                        return;
                    }
                    userIsOperate(state.intervalTime);
                };
        };

        const delayShowDialog = (delay: number) => {
            clearTimeout(state.delayTimer);
            state.delayTimer = setTimeout(() => {
                state.showDialog = true;
                const video = document.getElementsByTagName('video')[0];
                video?.pause();
            }, delay);
        };

        onMounted(() => {
            // 判断一下来源 如果是google的 不能弹弹窗
            const checkReg = /google/g;
            isFromGoogle.value = checkReg.test(document?.referrer);
            
            // 初始化state获取时会报错，所以放在这里获取
            state.hlsPlayUls = getHlsPlayUls(hlsPlayUls || '');
            addDialogHint();
            eventTracking();
            const pressUserOrFollowHandlerFllow = document.querySelector('#pressUserOrFollowHandlerFllow');
            if (pressUserOrFollowHandlerFllow) {
                pressUserOrFollowHandlerFllow.addEventListener('click', pressUserOrFollowHandler.bind(this, 'follow'), false);
            }
            const pressUserOrFollowHandlerJoin = document.querySelector('#pressUserOrFollowHandlerJoin');
            if (pressUserOrFollowHandlerFllow) {
                pressUserOrFollowHandlerJoin.addEventListener('click', pressUserOrFollowHandler.bind(this, 'join'), false);
            }

            window.addEventListener('load', () => {
                if (!inNewLiveStyle) {
                    return;
                }

                const isIOS = isIOSClient();
                if (!isIOS) {
                    userCallApp('autocallapp');
                }
            });

            // 阻断弹窗实验
            if (+abConfig?.blockTime) {
                const delay = isLiving ? abConfig?.blockTime * 1000 : 0;
                delayShowDialog(delay);
            }
        });
        onBeforeUnmount(() => {
            const video = document.getElementsByTagName('video')[0];
            const pressUserOrFollowHandlerFllow = document.querySelector('#pressUserOrFollowHandlerFllow');
            if (pressUserOrFollowHandlerFllow) {
                pressUserOrFollowHandlerFllow.removeEventListener('click', pressUserOrFollowHandler.bind(this, 'follow'), false);
            }
            const pressUserOrFollowHandlerJoin = document.querySelector('#pressUserOrFollowHandlerJoin');
            if (pressUserOrFollowHandlerJoin) {
                pressUserOrFollowHandlerJoin.removeEventListener('click', pressUserOrFollowHandler.bind(this, 'join'), false);
            }
            if (video) {
                video.removeEventListener('canplay', resizeVideo);
                video.removeEventListener('timeupdate', resizeVideo);
                // state.verticalScreen为true返回是为了防止重复计算
                video.removeEventListener('resize', resizeVideo);
            }
        });



        return {
            ...toRefs(state),
            isFromGoogle,
            localLang,
            userId,
            playingHandler,
            playEndHandler,
            playWaitingHandler,
            playerPlayingHandler,
            ASSETS,
            kpnInfo,
            shareUserInfo,
            pressUserOrFollowHandler,
            kpn,
            userInfo,
            liveOriginalSource,
            inNewLiveStyle,
            userActiveHandler,
            formateNum,
            isRtl,
            livePageConf,
            logParam,
            setWaiting,
            liveCoverUrl,
            startPopupTiming,
        };
    },
});